import React, { useState, useEffect } from "react";

const Inset = ({ contentUrl }) => {
  const [contentHtml, setContentHtml] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    if (!contentUrl) {
      setIsLoading(false);
      return;
    }

    const fetchContent = async () => {
      try {
        const response = await fetch(contentUrl);
        const html = await response.text();
        setContentHtml(html);
      } catch (e) {
        console.log("Failed to load inset content:", e);
      } finally {
        setIsLoading(false);
      }
    };

    fetchContent();
  }, [contentUrl]);

  // --- Rendering Logic ---

  if (isLoading || !contentHtml) {
    return null;
  }
  return (
    <div className="auto-resizable-iframe">
      <div dangerouslySetInnerHTML={{ __html: contentHtml }} />
    </div>
  );
};

export default Inset;
